<template>
  <div id="boardId">
    <div v-if="Object.keys(dynalt).length !== 0">
      <!-- 组态页面 -->
      <div class="pc-con" :style="pcConStyle()">
        <div class="editNav-side" :style="editNavStyle('outside')" v-if="editNavShow('outside')">
          <div class="editNav-item" :style="editNavItemStyle(index)" v-for="(item, index) in dynalt.config.canvas" :key="index"
            @mousedown="editNav_Event($event, index)">
            {{ item.name }}
          </div>
        </div>
        <div class="pc-edit">
          <div class="editCenter" :style="editCenterStyle()">
            <div class="editNav-side" :style="editNavStyle('inside')" v-if="editNavShow('inside')">
              <div class="editNav-item" :style="editNavItemStyle(index)" v-for="(item, index) in dynalt.config.canvas" :key="index"
                @mousedown="editNav_Event($event, index)">
                {{ item.name }}
              </div>
            </div>

            <div class="editCenter-item" v-for="(item,index) in pCanvas.element" :key="index" :style="elementBoxStyle(item.box,index)">
              <div class="editCenter-item-body">
                <!-- 基本-文本 -->
                <div v-if="item.type=='text_fields'" class="editCenter-base" :style="elementStyle(item)">{{item.value }}</div>
                <!-- 基本-时间 -->
                <div v-if="item.type=='date_range'" class="editCenter-base" :style="elementStyle(item)">{{item.value.local }}</div>
                <!-- 基本-超链接 -->
                <a v-if="item.type=='link'" class="editCenter-base" :style="elementStyle(item)+'cursor: pointer;'"
                  @click="link_Event(item.value.to)">{{item.value.name}}</a>
                <!-- 基本-刷新 -->
                <a v-if="item.type=='replay'" class="editCenter-base" :style="elementStyle(item)+'cursor: pointer;'"
                  @click="replay_Event()">{{ item.value }}</a>
                <!-- 基本-切换画布 -->
                <a v-if="item.type=='switch_video'" class="editCenter-base" :style="elementStyle(item)+'cursor: pointer;'"
                  @click="switchvideo_Event(item.value.to)">{{item.value.name}}</a>
                <!-- 基本-iframe -->
                <iframe v-if="item.type=='web'" class="editCenter-base" :src="item.value" />
                <!-- 基本-全屏 -->
                <img v-if="item.type=='fullscreen'" class="editCenter-base" style="cursor: pointer;"
                  :src="require('../assets/edit/fullscreen.svg')" @click="fullscreen_Event()" />
                <!-- 图库 and 上传 -->
                <img v-if="item.type=='material' || item.type=='image'" class="editCenter-base" :src="item.value" />
                <!-- 交互 -->
                <canvas v-if="item.type=='active'" :id="item.style.id" :height="item.box.height" :width="item.box.width"></canvas>
                <!-- 组件-数据 -->
                <div v-if="item.type=='data-value'" class="editCenter-base" :style="elementStyle(item)">
                  {{ dataShow(realtime[item.value.label.labelID], item.value.content, realtime.update) }}
                </div>
                <!-- 组件-开关 -->
                <div v-if="item.type=='data-switch'" class="editCenter-base" style="cursor: pointer;">
                  <img v-show="0==switchShow(realtime[item.value.label.labelID], realtime.update)" :src="item.value.closeImg" class="editCenter-base"
                    @click="switch_Event(item, 1)" />
                  <img v-show="1==switchShow(realtime[item.value.label.labelID], realtime.update)" :src="item.value.openImg" class="editCenter-base"
                    @click="switch_Event(item, 0)" />
                  <img v-show="-1==switchShow(realtime[item.value.label.labelID], realtime.update)" :src="item.value.errorImg" class="editCenter-base" />
                </div>
                <!-- 组件-控制 -->
                <img v-if="item.type=='data-control'" class="editCenter-base" style="cursor: pointer;" :src="item.value.img" @click="control_Event(item)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 下发控制 -->
      <mu-expand-transition>
        <div class="pc-control" v-if="control.enable">
          <div class="pc-control-head">
            <span>下发数据</span> {{control.item.value.label.name == ""?"未绑定数据":control.item.value.label.name}}
          </div>
          <div class="pc-control-body">
            <div class="pc-control-view">
              <div class="pc-control-view-item" v-for="(item,index) in control.log" :key="index">
                发送数据：{{item.value}}
                <span style="float:right">{{getTime(item.time)}}</span>
                <span style="float:right;margin-right:10px">{{item.msg}}</span>
              </div>
            </div>
            <textarea rows="3" v-model="control.value"></textarea>
            <div class="pc-control-btn">
              <mu-button small color="grey50" @click="control_Handle('cancel')" style="color:#000">关闭</mu-button>
              <mu-button small color="primary" @click="control_Handle('send')">发送</mu-button>
            </div>
          </div>
        </div>
      </mu-expand-transition>
    </div>
  </div>
</template>

<script>
import { dynalt_Retrieve } from "../network/dynalt.js";
import { tolink_Realtime, tolink_Mqttwrite } from "../network/tolink.js";
import { control, getUrlKey, regPos, regNeg } from "../assets/option.js";
import { setScreen } from "@/utils/utils.js";

export default {
  data() {
    return {
      id: "",
      dynalt: {},
      url: "",
      dynalt: {},
      realtime: { update: 0 },

      canvasCur: 0,

      time: {
        unix: 0,
        local: "now time",
      },
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight,

      control,
      regPos,
      regNeg,
    };
  },
  mounted() {
    this.id = getUrlKey("id");
    this.token = getUrlKey("token");
    this.url = document.URL;

    this.dynaltRetrieve(this.id);

    setInterval(() => {
      this.time.unix = new Date().getTime() / 1000;
      this.time.local = this.getDatetime();
    }, 1000);

    window.onresize = () => {
      return (() => {
        this.windowHeight = document.documentElement.clientHeight;
        this.windowWidth = document.documentElement.clientWidth;
      })();
    };

    setInterval(this.activeHandle, 10);
    setInterval(this.dataHandle, 1000);
    this.appEventListener() // 监听App原生返回按钮（5+ API）
  },
  methods: {
    appEventListener() { // 监听App原生返回按钮（5+ API）
      document.addEventListener('plusready', () => {
        plus.key.addEventListener('backbutton', () => {
          plus.webview.currentWebview().close()
        })
      })
    },
    /* - - - - - - - */

    editNavShow(mode) {
      return (
        this.dynalt.config.canvas.length > 1 &&
        this.dynalt.config.nav.float == mode &&
        !this.dynalt.config.nav.enable
      );
    },

    /* - - - - - - - */

    dataHandle() {
      if (Object.keys(this.dynalt).length == 0) return;
      let request = {};
      let cycle = 0;
      let timeNow = parseInt(new Date().getTime() / 1000);

      for (let canvas of this.dynalt.config.canvas) {
        for (let element of canvas.element) {
          switch (element.type) {
            case "data-value":
            case "data-switch":
            case "active":
              if (element.type == "active") {
                switch (element.style.type) {
                  case "active-pool":
                    break;
                  default:
                    continue;
                }
              }

              cycle =
                Math.trunc(element.value.cycle) < 3 ? 3 : element.value.cycle;
              if (
                (timeNow % cycle == 0 || !element.value.update) &&
                element.value.stream["api-key"] !== "" &&
                element.value.label["labelID"] !== ""
              ) {
                element.value.update = true;
                if (!(element.value.stream["api-key"] in request)) {
                  request[element.value.stream["api-key"]] = [];
                }
                let exist = false;
                for (let labelID of request[element.value.stream["api-key"]]) {
                  if (labelID == element.value.label.labelID) {
                    exist = true;
                    break;
                  }
                }
                if (!exist) {
                  request[element.value.stream["api-key"]].push(
                    element.value.label.labelID
                  );
                }
              }
              break;
          }
        }
      }

      if (Object.keys(request).length > 0) {
        for (let index in request) {
          this.tolinkRealtime(index, request[index]);
        }
      }
    },

    /* - - - - - - - */

    activeHandle() {
      if (Object.keys(this.dynalt).length == 0) return;
      for (let canvas of this.dynalt.config.canvas) {
        for (let element of canvas.element) {
          if (element.type == "active") {
            switch (element.style.type) {
              case "active-pipe":
                this.active_pipeHandle(element);
                break;
              case "active-pool":
                this.active_poolHandle(element);
                break;
            }
          }
        }
      }
    },
    active_pipeHandle(ele) {
      let canvas = document.getElementById(ele.style.id);
      if (canvas == undefined) return;
      let context = canvas.getContext("2d");

      ele.style.move += 0.6;
      if (ele.style.move >= ele.box.height * 3) {
        ele.style.move = 0;
      }

      context.clearRect(0, 0, ele.box.width, ele.box.height);
      context.lineWidth = 0.01;
      context.shadowOffsetX = 0;
      context.shadowOffsetY = 0;
      context.shadowBlur = 0;
      context.shadowColor = "RGB(42, 154, 199)";

      let gradient = context.createLinearGradient(
        0,
        0,
        0,
        ele.box.height * 0.5
      );
      gradient.addColorStop(0, "#8c96aa");
      gradient.addColorStop(1, "#ffffff");

      let gradient2 = context.createLinearGradient(
        0,
        ele.box.height * 0.5,
        0,
        ele.box.height
      );
      gradient2.addColorStop(0, "#ffffff");
      gradient2.addColorStop(1, "#8c96aa");

      context.fillStyle = gradient;
      if (context.fillStyle === '#000000') { // 被嵌入到 uni-app 中时, #号后面不能超过6位
        context.fillStyle = gradient.slice(0, 7)
      }
      context.fillRect(0, 0, ele.box.width, ele.box.height * 0.5);

      context.fillStyle = gradient2;
      if (context.fillStyle === '#000000') { // 被嵌入到 uni-app 中时, #号后面不能超过6位
        context.fillStyle = gradient2.slice(0, 7)
      }
      context.fillRect(
        0,
        ele.box.height * 0.5,
        ele.box.width,
        ele.box.height * 0.5
      );

      context.shadowBlur = 3;
      context.fillStyle = ele.style.color;
      if (context.fillStyle === '#000000') { // 被嵌入到 uni-app 中时, #号后面不能超过6位
        context.fillStyle = ele.style.color.slice(0, 7)
      }

      for (let idx = -1; idx < ele.box.width / (ele.box.height * 3); idx++) {
        context.fillRect(
          idx * ele.box.height * 3 + ele.style.move,
          ele.box.height * 0.17,
          ele.box.height * 2,
          ele.box.height * 0.66
        );
      }

      context.fill();
    },
    active_poolHandle(ele) {
      let canvas = document.getElementById(ele.style.id);
      if (canvas == undefined) return;
      let context = canvas.getContext("2d");

      let range = 0;
      let show = "";
      let vaule = this.dataShow(
        this.realtime[ele.value.label.labelID],
        ele.value.content,
        this.realtime.update
      );

      switch (vaule) {
        case "暂无":
        case "异常":
          range = ele.value.max / 100;
          show = vaule;
          break;
        default:
          range = (vaule - ele.value.min) / (ele.value.max - ele.value.min);
          show = Math.trunc(range * 100) + "%";
      }

      if (range < 0) {
        range = 0;
        show = "<0%";
      }
      if (range > 1) {
        range = 1;
        show = ">100%";
      }
      if (ele.value.max <= ele.value.min) {
        range = 0;
        show = "峰值？";
      }

      ele.style.move = ele.style.move > 100 ? 0 : ele.style.move + 0.05;

      context.clearRect(0, 0, ele.box.width, ele.box.height);
      context.beginPath();

      let points = [];
      for (var x = 0; x < 0 + ele.box.width; x += 20 / ele.box.width) {
        var y = -Math.sin((0 + x) * 0.01 + ele.style.move);
        var dY = ele.box.height * (1 - range);
        points.push([x, dY + y * 6]);
        context.lineTo(x, dY + y * 6);
      }

      context.lineTo(ele.box.width, ele.box.height);
      context.lineTo(0, ele.box.height);
      context.lineTo(points[0][0], points[0][1]);
      context.fillStyle = ele.style.waveColor;
      if (context.fillStyle === '#000000') { // 被嵌入到 uni-app 中时, #号后面不能超过6位
        context.fillStyle = ele.style.waveColor.slice(0, 7)
      }
      context.fill();
      context.restore();

      context.textAlign = "center";
      context.fillStyle = ele.style.color;
      if (context.fillStyle === '#000000') { // 被嵌入到 uni-app 中时, #号后面不能超过6位
        context.fillStyle = ele.style.color.slice(0, 7)
      }
      context.font = ele.style.fontSize + "px wryh";
      context.fillText(
        ele.value.show ? show : "",
        ele.box.width / 2,
        ele.box.height / 2
      );
    },

    /* - - - - - - - */

    pcConStyle() {
      let styleStr = "";

      switch (this.dynalt.config.nav.position) {
        case "top":
          styleStr += "flex-flow: column;";
          break;
        case "bottom":
          styleStr += "flex-flow: column; flex-direction:column-reverse;";
          break;
        case "left":
          break;
        case "right":
          styleStr += "flex-direction:row-reverse;";
          break;
      }

      return styleStr;
    },
    editCenterStyle() {
      let styleStr = "";

      let centerLeft =
        (-(1 - this.windowWidth / this.dynalt.config.board.width) *
          this.dynalt.config.board.width) /
        2;

      let centerTop =
        (-(1 - this.windowWidth / this.dynalt.config.board.width) *
          this.dynalt.config.board.height) /
        2;

      styleStr += "background:";
      styleStr += this.dynalt.config.canvas[this.canvasCur].background + ";";
      styleStr += "width:" + this.dynalt.config.board.width + "px;";
      styleStr += "height:" + this.dynalt.config.board.height + "px;";
      styleStr += "transform:scale(";
      styleStr += this.windowWidth / this.dynalt.config.board.width + ");";
      styleStr += "left:" + centerLeft + "px;";
      styleStr += "top:" + centerTop + "px;";

      return styleStr;
    },
    editNavStyle(side) {
      let styleStr = "";

      styleStr += "background:" + this.dynalt.config.nav.background + ";";

      if (side == "outside") {
        switch (this.dynalt.config.nav.position) {
          case "top":
          case "bottom":
            styleStr += "width:100%; height:40px;";
            styleStr += "overflow-x:auto; overflow-y:hidden;";
            break;
          case "left":
          case "right":
            styleStr += "height:100%;";
            styleStr += "overflow-x:hidden; overflow-y:auto;";
            break;
        }
      } else {
        styleStr += "position:absolute; z-index: 1000;";
        switch (this.dynalt.config.nav.position) {
          case "top":
            styleStr += "top:0; left:0; width:100%; height:40px;";
            styleStr += "overflow-x:auto; overflow-y:hidden;";
            break;
          case "bottom":
            styleStr += "bottom:0; left:0; width:100%; height:40px;";
            styleStr += "overflow-x:auto; overflow-y:hidden;";
            break;
          case "left":
            styleStr += "top:0; left:0; height:100%;";
            styleStr += "overflow-x:hidden; overflow-y:auto;";
            break;
          case "right":
            styleStr += "top:0; right:0; height:100%;";
            styleStr += "overflow-x:hidden; overflow-y:auto;";
            break;
        }
      }

      return styleStr;
    },
    editNavItemStyle(idx) {
      let styleStr = "";

      styleStr += "color:" + this.dynalt.config.nav.color + ";";
      styleStr +=
        this.canvasCur == idx
          ? "background:" + this.dynalt.config.nav.checkColor + ";"
          : "";
      switch (this.dynalt.config.nav.position) {
        case "top":
        case "bottom":
          styleStr += "display: inline-block;";
          break;
        case "left":
        case "right":
          break;
      }

      return styleStr;
    },
    elementBoxStyle(box, idx) {
      let styleStr = "";
      styleStr += "width:" + box.width + "px;";
      styleStr += "height:" + box.height + "px;";
      styleStr += "top:" + box.top + "px;";
      styleStr += "left:" + box.left + "px;";
      styleStr += "z-index:" + idx + ";";
      styleStr += "transform:rotate(" + Math.trunc(box.rotate) + "deg);";
      styleStr += "background:" + box.background + ";";
      return styleStr;
    },
    elementStyle(item) {
      let styleStr = "";
      switch (item.type) {
        default:
          for (let idx in item.style) {
            switch (idx) {
              case "fontSize":
                styleStr += idx + ":" + item.style[idx] + "px;";
                break;
              case "lineHeight":
                if (item.style[idx] == "0")
                  styleStr += idx + ":" + item.box.height + "px;";
                else styleStr += idx + ":" + item.style[idx] + ";";
                break;
              default:
                styleStr += idx + ":" + item.style[idx] + ";";
            }
          }
          break;
      }
      return styleStr;
    },

    /* - - - - - - - */

    editNav_Event(event, idx) {
      this.canvasCur = event.button == 0 ? idx : this.canvasCur;
    },
    link_Event(url) {
      window.open(url);
    },
    fullscreen_Event() {
      this.isFullscreen = !this.isFullscreen
      setScreen('boardId', this.isFullscreen)

      // iframe内的全屏不生效
      const msg = {
        isFullscreen: this.isFullscreen
      }
      window.parent.postMessage(msg, "*") // 向父页面发送数据
    },
    replay_Event() {
      window.location.href = this.url;
    },
    switchvideo_Event(idx) {
      if (idx >= 0) {
        this.canvasCur = idx;
        this.elementCur = -1;
      }
    },

    /* - - - - - - - */

    dataShow(data, content) {
      if (typeof data !== "object") return "暂无";
      if (data.status <= 0) return "异常";
      switch (content) {
        case "value":
          return data.value;
        case "time":
          return this.getDatetime(data.time);
        default:
          return "";
      }
    },
    switchShow(data) {
      if (typeof data !== "object" || data.status <= 0) return -1;
      if (data.value == 0) return 0;
      else return 1;
    },
    switch_Event(item, val) {
      if (
        item.value.stream["api-key"] == "" ||
        item.value.label.labelID == ""
      ) {
        this.$alert("开关未绑定数据", "提示", {
          okLabel: "知道了",
        });
        return;
      }
      this.$confirm(
        (val == 0 ? "关闭 " : "开启 ") + item.value.label.name + "？",
        "提示",
        {}
      ).then(({ result }) => {
        if (result) {
          this.tolinkMqttwrite(
            item.value.stream["api-key"],
            item.value.label.labelID,
            val
          );
        }
      });
    },
    control_Event(item) {
      this.control = { enable: true, item, value: "", log: [] };
    },

    /* - - - - - - - */

    dynaltRetrieve(id) {
      dynalt_Retrieve(id)
        .then(res => {
          if (res.data.code == 200) {
            this.dynalt = res.data.return.dynalt2;
            if (this.dynalt.config.canvas == 0) {
              this.dynalt.config.canvas.push({
                name: "画布1（右键删除）",
                background: "#fff",
                element: [],
              });
            }
          } else {
            this.$toast.error("组态不存在");
          }
        })
        .catch(this.catchErr);
    },

    /* - - - - - - - */

    tolinkRealtime(apiKey, list) {
      tolink_Realtime(apiKey, list)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.labels == null) {
              res.data.return.labels = [];
            }
            for (let index in res.data.return.labels) {
              this.realtime[res.data.return.labels[index]] = {
                value: res.data.return.values[index],
                status: res.data.return.status[index],
                time: res.data.return.times[index],
              };
              this.realtime.update =
                this.realtime.update > 19970801 ? 0 : this.realtime.update + 1;
            }
          }
        })
        .catch(this.catchErr);
    },
    tolinkMqttwrite(apiKey, labelID, value, log) {
      tolink_Mqttwrite(apiKey, labelID, value)
        .then(res => {
          if (log) {
            this.control.log.unshift({
              value,
              time: Math.round(new Date().getTime() / 1000),
              msg: res.data.msg,
            });
          } else {
            if (res.data.code == 200) {
              this.$toast.success("下发成功，等待响应");
            } else {
              this.$toast.error(res.data.msg);
            }
          }
        })
        .catch(this.catchErr);
    },
    /* - - - - - - - */

    getTime(time) {
      var now = time > 0 ? new Date(time * 1000) : new Date();
      var hh = now.getHours();
      var mm = now.getMinutes();
      var ss = now.getSeconds();
      var clock = "";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += "0";
      clock += mm + ":";
      if (ss < 10) clock += "0";
      clock += ss;
      return clock;
    },
    getDatetime(time) {
      var now = time > 0 ? new Date(time * 1000) : new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var hh = now.getHours();
      var mm = now.getMinutes();
      var ss = now.getSeconds();
      var clock = year + "-";
      if (month < 10) clock += "0";
      clock += month + "-";
      if (day < 10) clock += "0";
      clock += day + " ";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += "0";
      clock += mm + ":";
      if (ss < 10) clock += "0";
      clock += ss;
      return clock;
    },
    control_Handle(btn) {
      switch (btn) {
        case "send":
          if (
            this.control.item.value.stream["api-key"] == "" ||
            this.control.item.value.label.labelID == ""
          ) {
            return;
          }
          if (
            !this.regPos.test(this.control.value) &&
            !this.regNeg.test(this.control.value)
          ) {
            this.control.log.unshift({
              value: this.control.value,
              time: Math.round(new Date().getTime() / 1000),
              msg: "请输入数字",
            });
            return;
          }
          this.tolinkMqttwrite(
            this.control.item.value.stream["api-key"],
            this.control.item.value.label.labelID,
            parseFloat(this.control.value),
            true
          );
          break;
        case "cancel":
          this.control = { enable: false, item: null, value: "", log: [] };
          break;
      }
    },
  },
  computed: {
    pCanvas() {
      return this.dynalt.config.canvas[this.canvasCur];
    },
    pElement() {
      if (this.elementCur < 0) {
        return {};
      }
      return this.pCanvas.element[this.elementCur];
    },
  },
};
</script>

<style scoped>
.pc-con {
  position: relative;
  display: flex;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.pc-edit {
  flex: 1;
  overflow: auto;
}
.pc-edit::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.editNav-side {
  background: green;
  text-align: center;
  white-space: nowrap;
}
.editNav-side::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}
.editNav-side::-webkit-scrollbar-thumb {
  background: #666;
}
.editNav-side::-webkit-scrollbar-track {
  background: #fff;
}
.editNav-item {
  height: 40px;

  line-height: 40px;
  padding: 0 10px;
  user-select: none;
  cursor: pointer;
}

.editCenter {
  position: relative;
  display: inline-block;
  transition: all 0.5s;
}
.editCenter-item {
  position: absolute;
  display: inline-block;
}
.editCenter-item-body {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.editCenter-base {
  width: 100%;
  height: 100%;

  white-space: pre;
  overflow: hidden;
}
.editCenter-base,
.editCenter-base * {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}

.pc-control {
  position: fixed;
  top: calc(50% - 190px - 60px);
  left: calc(50% - 200px);
  width: 400px;
  height: 380px;
  z-index: 19970804;

  background: #fff;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.1);
}

.pc-control-head {
  width: 100%;
  height: 40px;
  background: #f5f5f5;
  color: #333;
  padding: 0 15px;
  border-bottom: 1px solid #ccc;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.pc-control-head span {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 500;
  margin-right: 10px;
}

.pc-control-body {
  padding: 15px;
}
.pc-control-body .pc-control-view {
  width: 100%;
  height: 170px;
  border: 1px solid #ccc;

  overflow-y: scroll;
  overflow-x: auto;

  margin-bottom: 20px;
  padding: 5px 0;
}
.pc-control-body .pc-control-view-item {
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  font-size: 12px;
}
.pc-control-body textarea {
  display: inline-block;
  width: 100%;
  height: 72px;

  border: 1px solid #ccc;
  padding: 6px 12px;
  outline: none;
  margin: none;
  overflow-x: hidden;

  font-size: 14px;
  color: #555;
}
.pc-control-body textarea::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.pc-control-body textarea::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #000;
}
.pc-control-body textarea::-webkit-scrollbar-track {
  border-radius: 0;
  background: #aaa;
}
.pc-control-btn {
  margin-top: 10px;
  height: 30px;
}
.pc-control-btn .mu-button {
  float: right;
  margin-left: 10px;
}
</style>